// src/shared-components/select-followup-destino-baixa/QCXSelectFollowUpDestinoAutocompleteField.jsx
import React, { useEffect, useMemo, useState } from 'react';
import { createFilterOptions } from '@material-ui/lab/useAutocomplete';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

import QCXAutocompleteSelect from '../autocomplete-select/QCXAutocompleteSelect';
import followUpDestinoBaixaThunks from '../../features/follow-up-destino-baixa/followUpDestinoBaixaThunks';
import followUpDestinoBaixaSelectors from '../../features/follow-up-destino-baixa/followUpDestinoBaixaSelectors';

export default function QCXSelectFollowUpDestinoAutocompleteField({
  label,
  name,
  origemFollowupId,             
  placeholder,
  controlled = false,           
  internalLoadingAtStart = true,
  disabled = false,
  initialValues,
  onChange,                     
  ...restProps
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const list = useSelector(followUpDestinoBaixaSelectors.selectFollowUps); // [{id, numero, cliente}]
  const [defaultValue, setDefaultValue] = useState({ id: null, numero: '', cliente: '' });
  const [internalLoading, setInternalLoading] = useState(internalLoadingAtStart);

  useEffect(() => {
    if (!controlled && origemFollowupId) {
      dispatch(followUpDestinoBaixaThunks.fetchByOrigemAsync(origemFollowupId));
    }
  }, [controlled, origemFollowupId, dispatch]);

  useEffect(() => {
    if (!_.isEmpty(list)) {
      setInternalLoading(false);
    }
  }, [list]);

  useEffect(() => {
    const found = list?.find((it) => it?.id === _.get(initialValues, name));
    if (found) setDefaultValue(found);
    else setDefaultValue({ id: null, numero: '', cliente: '' });
  }, [list, initialValues, name]);

  const filterOptions = useMemo(
    () =>
      createFilterOptions({
        stringify: (option) => `${option?.numero || ''}`,
      }),
    []
  );

  return (
    <QCXAutocompleteSelect
      label={label}
      id={name}
      name={name}
      options={list || []}
      filterOptions={filterOptions}
      defaultValue={defaultValue}
      getOptionLabel={(item) => item?.numero || ''}
      getOptionSelected={(o, v) => o?.id === v?.id}
      onChange={onChange}
      {...restProps}
      placeholder={placeholder}
      loading={internalLoading}
      loadingText={t('com.muralis.qcx.carregando')}
      disabled={internalLoading || disabled}
      renderOption={(option) => `${option.numero}`}
    />
  );
}
